import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import includes from 'lodash/includes'
import matches from 'lodash/matches'
import find from 'lodash/find'
import isNil from 'lodash/isNil'
import Button from '@vtex/styleguide/lib/Button'

import GiftCardSelector from '../Selector/GiftCardSelector'
import PaymentSystemSelector from '../Selector/PaymentSystemSelector'
import NumberInput from '@/checkout-instore-legacy/components/Commons/NumberInput'
import Price from '@/checkout-instore-legacy/components/Commons/Price'
import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'

export default class AddPaymentForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedPayment: null,
      selectedPaymentType: null,
      value: props.initialValue > 0 ? props.initialValue : 0,
      modifiedValue: false,
    }
  }

  static getDerivedStateFromProps(props, state) {
    const { giftCards, paymentSystems } = props
    return state.selectedPayment
      ? {
          selectedPayment: find(
            [...giftCards, ...paymentSystems],
            matches({
              id: state.selectedPayment.id,
            })
          ),
        }
      : null
  }

  handleSelectPayment(selectedPayment, selectedPaymentType) {
    this.setState({ selectedPayment, selectedPaymentType })
  }

  handleValueChange(newValue) {
    const { maxValue } = this.props
    const value =
      typeof maxValue === 'number' && newValue > maxValue ? maxValue : newValue
    this.setState({ value })
  }

  canSubmit() {
    const selectedPaymentIsPaymentSystem = includes(
      this.props.paymentSystems,
      this.state.selectedPayment
    )
    const selectedPaymentIsGiftCard = includes(
      this.props.giftCards,
      this.state.selectedPayment
    )
    return (
      (selectedPaymentIsPaymentSystem && this.state.value > 0) ||
      selectedPaymentIsGiftCard
    )
  }

  getValidationMessage() {
    if (!isNil(this.props.remainingValue)) {
      const remainingValue = this.props.remainingValue - this.state.value

      if (remainingValue < 0) {
        return (
          <div key="0" className="tc light-red mb5 f4-ns">
            <FormattedMessage id="addPaymentFormValueGreaterThanTotalValidation" />{' '}
            <span className="fw4">
              <Price value={-remainingValue} />
            </span>
          </div>
        )
      }
    }

    return null
  }

  renderValueErrorMessage() {
    return this.state.value === 0 && this.state.modifiedValue ? (
      <FormattedMessage
        id="addPaymentFormValueGreaterThanZero"
        values={{
          zero: (
            <strong>
              <FormattedMessage id="zero" />
            </strong>
          ),
        }}
      />
    ) : null
  }

  render() {
    const { selectedPayment, selectedPaymentType, value } = this.state

    return (
      <div id={this.props.id}>
        <GiftCardSelector
          id={buildChildId('giftcards', this.props.id)}
          selected={this.state.selectedPayment}
          giftCards={this.props.giftCards}
          onSelect={(gc) => this.handleSelectPayment(gc, 'gift-card')}
          hideGiftCardsInUse
        />
        <PaymentSystemSelector
          id={buildChildId('payments', this.props.id)}
          value={this.state.value}
          selected={this.state.selectedPayment}
          paymentSystems={this.props.paymentSystems}
          installmentOptions={this.props.installmentOptions}
          onSelect={(ps) => this.handleSelectPayment(ps, 'payment-system')}
          sellersWithoutPermission={this.props.sellersWithoutPermission}
          filterEcommercePayment
          isAddNewPayment
        />

        <form
          className="tc ph5"
          onSubmit={(e) => {
            e.preventDefault()
            this.props.onSubmit(selectedPayment, selectedPaymentType, value)
          }}
        >
          {this.state.selectedPaymentType !== 'gift-card' &&
          !this.props.hideValueInput ? (
            <div className="pt2 pb4 tl mt7">
              <NumberInput
                id={buildChildId('value', this.props.id)}
                labelId="addPaymentFormValue"
                className="f4 f3-ns tl"
                value={this.state.value}
                onChange={(v) => this.handleValueChange(v)}
                onBlur={() => this.setState({ modifiedValue: true })}
                onFocus={() => this.setState({ modifiedValue: false })}
                errorMessage={this.renderValueErrorMessage()}
              />
            </div>
          ) : null}

          {this.getValidationMessage()}

          <div className="flex justify-end mt7">
            <Button
              id={buildChildId('button-confirm', this.props.id)}
              type="submit"
              variation="primary"
              size="large"
              disabled={!this.canSubmit()}
            >
              <FormattedMessage id="addPaymentFormAdd" />
            </Button>
          </div>
        </form>
      </div>
    )
  }
}

AddPaymentForm.propTypes = {
  id: PropTypes.string,
  giftCards: PropTypes.array,
  paymentSystems: PropTypes.array,
  installmentOptions: PropTypes.array,
  initialValue: PropTypes.number,
  remainingValue: PropTypes.number,
  maxValue: PropTypes.number,
  hideValueInput: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  sellersWithoutPermission: PropTypes.arrayOf(PropTypes.string).isRequired,
}
